import { FC, useState } from 'react'

import { AgGridApp, Spinner } from '@/components'
import { Workflow } from '@/models/sellTreez'

import { useSellTreezWorkflows } from '../hooks'
import { columnsWorkflows } from '../data/columnsWorkflows'
import { WorkflowCompareModal } from './WorkflowCompareModal'

const SellTreezWorkflowsTabContent: FC = () => {
  const { workflows, isLoading } = useSellTreezWorkflows()
  const [selectedWorkflow, setSelectedWorkflow] = useState<Workflow | undefined>(undefined)
  const columnsWorkflowsDefs = columnsWorkflows(setSelectedWorkflow)

  return (
    <>
      <div className="flex flex-col gap-6">
        <div className="text-gray-800 font-medium">Workflows</div>
        {isLoading ? (
          <Spinner />
        ) : (
          <AgGridApp
            rowData={workflows}
            columnDefs={columnsWorkflowsDefs}
            isShowPagination={false}
            isShowFilter={false}
            paginationPageSize={20}
          />
        )}
      </div>
      <WorkflowCompareModal
        workflow={selectedWorkflow}
        handleCloseModal={() => {
          setSelectedWorkflow(undefined)
        }}
      />
    </>
  )
}

export { SellTreezWorkflowsTabContent }
